import cn from "@/v2-ui/utils/utils.cn"
import { DotText } from "@/v2-backoffice-client/components/dot"
import InfoGrid, {
  type InfoGridProps,
  createInfoGridFields,
} from "@/v2-backoffice-client/components/infoGrid"
import BasemapThumbnail from "@/v2-backoffice-client/basemap/BasemapThumbnail"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

const FIELDS = createInfoGridFields<BasemapFragment>({
  fields: {
    FeatureCode: {
      label: "Feature Code",
      accessor: "FeatureCode",
    },
    Priority: {
      label: "Order",
      accessor: "Priority",
    },
    Thumbnail: {
      label: "Thumbnail",
      accessor: "Thumbnail",
      renderValue({ data }) {
        return <BasemapThumbnail src={data.Thumbnail} name={data.Name} />
      },
    },
    IsEnabled: {
      label: "Status",
      accessor: "IsEnabled",
      renderValue({ value }) {
        return (
          <DotText variant={value ? "success-1" : "destructive"}>
            {value ? "Enabled" : "Disabled"}
          </DotText>
        )
      },
    },
  },
})

export type BasemapViewInfoProps = Omit<
  InfoGridProps<BasemapFragment>,
  "data" | "fields"
> & {
  basemap: BasemapFragment | null | undefined
}

function BasemapViewInfo(props: BasemapViewInfoProps) {
  const { basemap, className, ...infoGridProps } = props

  return (
    <InfoGrid
      id="basemap-info"
      className={cn("basemap-view-info", className)}
      data={basemap}
      fields={FIELDS}
      {...infoGridProps}
    />
  )
}

export default BasemapViewInfo
